<modal #modal [css-class]="'age-restriction'">
    <div class="modal-header">
        <h5 class="modal-title"><ng-content select="header"></ng-content></h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCloseClick()">
            
        </button>
    </div>
    <div class="modal-body">
        <ng-content select="content"></ng-content>
    </div>
    <div class="modal-footer">
        <app-opening-hours></app-opening-hours>
    </div>
</modal>
